import React from "react";

function Launches() {

    return (

        <div>
          <embed
            src="https://spaceflightnow.com/launch-schedule/"
            width={843}
            height={474}
          />
        </div>  

    )

}

export default Launches 